const zh = {
  i18nView: {
    login: '登录',
    logout: '登出',
    basePrice: '起拍价格',
    auctionConfirm: '确认竞拍',
    search: '搜索',
    currentPrice: '当前价格',
    bidder: '出价人',
    finished: '已结束',
    hour: '时',
    minute: '分',
    second: '秒',
    claim: '领取账号',
    bidFinished: '竞拍完成',
    bidded: '已出价',
    joinBid: '参与竞拍',
    please: '请先',
    loginFirst: '请先登录',
    newAuction: '新竞拍',
    pubkeyToReceive: '接收账号的公钥',
    searchPlaceholder: '搜索你要竞拍的账号4-7位',
    dealPrice: '成交价格',
    bidOwner: '竞拍得主',
    dealTime: '成交时间',
    auction: '当前竞拍',
    mine: '我的竞拍',
    deal: '成交列表',
    rules: '竞拍规则',
    accountLength: '短号长度',
    accountLengthDesc: '可竞拍含\'.tp\'结尾的7—10位短号',
    newAccount: '账号提名',
    newAccountDesc: '若搜索地账号暂未存在于竞拍列表中，即提交账号竞拍申请',
    process: '竞价流程',
    processDesc: '每次竞价最少增加500 TPT',
    dealRules: '成交规则',
    dealDesc: '仅价格前50名的短号会在倒计时后成功交易。每次新竞价倒计时重置为12小时',
    PublicKeyFirst: '请填写接收账号的公钥',
    bidSuccess: '竞拍成功',
    claimSuccess: '领取成功',
    lengthTips: '只允许创建4-7位自定义短账号'
  }
};

export default zh;
